import { Injectable } from '@angular/core';
import { BundlesRepositoryService, ConfigurationState, SelectOption, UserGroupAccessRepositoryService } from 'reg-hub-common';
import { BehaviorSubject, forkJoin, from, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EagerFetchRepositoryService {
  public userGroupOptions = new BehaviorSubject<SelectOption[]>([]);
  public bundleOptions = new BehaviorSubject<SelectOption[]>([]);

  // Okay let's not go hog wild with this concept but there are certain HOT paths that we can eagerly load
  // information for the client to make the portal feel snappier.

  constructor(
    private configurationState: ConfigurationState,
    private userGroupAccessRepo: UserGroupAccessRepositoryService,
    private bundlesRepo: BundlesRepositoryService) { }

  fetchInitialRequestPageOptions() {
    const getUserGroups = this.userGroupAccessRepo.getWriteableUserAccessesAsSelectOptions().pipe(
      tap(userGroupOptions => {
        if (userGroupOptions.length > 0) {
          this.userGroupOptions.next(userGroupOptions);
        }
      }));
    const getBundles = from(this.configurationState.getCorporationID()).pipe(
      switchMap(corporationID => this.bundlesRepo.getBundlesAsSelectOptions(corporationID)),
      tap(bundleOptions => {
        if (bundleOptions.length > 0) {
          this.bundleOptions.next(bundleOptions);
        }
      }));

    return forkJoin([getUserGroups, getBundles])
  }
}
